import { registerPlugin, Capacitor } from '@capacitor/core';

// Safe web fallback so imports don't throw in a desktop browser (no native
// Capacitor plugin there — the browser's own WebRTC handles audio routing).
let AudioRoute;
if (Capacitor.isNativePlatform()) {
  AudioRoute = registerPlugin('AudioRoute');
} else {
  AudioRoute = {
    setCallMode: async () => Promise.resolve({ active: false, speaker: false }),
    setSpeaker: async () => Promise.resolve({ speaker: false }),
    getSpeaker: async () => Promise.resolve({ speaker: false }),
    startInboundRingPoll: async () => Promise.resolve(),
    stopInboundRingPoll: async () => Promise.resolve(),
    storePushDeviceSecret: async () => Promise.resolve(),
    clearPushDeviceSecret: async () => Promise.resolve(),
    requestPushPermissions: async () => Promise.resolve({ notificationsAllowed: true, fullScreenIntentAllowed: false, batteryOptimizationExempt: false }),
    getPushReadiness: async () => Promise.resolve({ platform: 'web', hasDeviceSecret: false, lastKnownToken: '', notificationsAllowed: true, fullScreenIntentAllowed: false, batteryOptimizationExempt: false }),
  };
}

export default AudioRoute;
